import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import JsBarcode from 'jsbarcode'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

function reportOrcNoWMS(dados_pedido, tipoImpressao) {
  console.log({ dados_pedido, tipoImpressao })
  try {
    const {
      itens: clientes,
      detalhes_pedido: obs,
      cliente: NomeCliente,
      Parceiro,
      numeroorc,
      data,
      cpf,
      dadosDoCliente: DadosCliente,
      empresa
    } = dados_pedido

    const empresaInfo = empresa[0]
    const dataFormatada = format(parseISO(data), 'dd/MM/yyyy', { locale: ptBR })

    // Utilitários
    const formatarCPFouCNPJ = (cpfOuCnpj) => {
      if (!cpfOuCnpj) return 'N/I'

      if (cpfOuCnpj.length === 11) {
        return cpfOuCnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
      } else if (cpfOuCnpj.length === 14) {
        return cpfOuCnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
      }
      return cpfOuCnpj
    }

    const generateBarcode = (data) => {
      const canvas = document.createElement('canvas')
      JsBarcode(canvas, data, {
        format: 'CODE128',
        height: 35,
        displayValue: false,
        margin: 0
      })
      return canvas.toDataURL('image/png')
    }

    const formatCurrency = (value) => {
      if (value === null || isNaN(value)) return 'R$ 0,00'
      return Number(value).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
      })
    }

    const formatNumber = (value) => {
      if (value === null || isNaN(value)) return '0,00'
      return Number(value).toFixed(2).replace('.', ',')
    }

    // Configuração do PDF
    pdfMake.addVirtualFileSystem(pdfFonts)

    // Cores modernas (iguais ao pedido)
    const primaryColor = '#1e40af'      // Azul moderno
    const accentColor = '#3b82f6'       // Azul claro
    const successColor = '#10b981'      // Verde
    const darkColor = '#1f2937'         // Cinza escuro
    const lightGray = '#f8fafc'         // Cinza claro
    const borderColor = '#e5e7eb'       // Bordas
    const warningColor = '#f59e0b'      // Laranja para orçamento

    // Estilos modernos (iguais ao pedido)
    const styles = {
      title: {
        fontSize: 22,
        bold: true,
        color: primaryColor,
        margin: [0, 0, 0, 10]
      },
      subtitle: {
        fontSize: 14,
        bold: true,
        color: accentColor,
        margin: [0, 15, 0, 8]
      },
      sectionTitle: {
        fontSize: 12,
        bold: true,
        color: primaryColor,
        margin: [0, 10, 0, 5]
      },
      tableHeader: {
        fillColor: primaryColor,
        color: 'white',
        bold: true,
        fontSize: 9,
        alignment: 'center'
      },
      tableCell: {
        fontSize: 8,
        margin: [2, 4, 2, 4]
      },
      tableCellBold: {
        fontSize: 8,
        bold: true,
        margin: [2, 4, 2, 4]
      },
      totalRow: {
        fillColor: lightGray,
        fontSize: 9,
        bold: true
      },
      highlight: {
        fillColor: '#eff6ff',
        color: primaryColor
      }
    }

    // Dados calculados
    const cpfFormatado = formatarCPFouCNPJ(cpf)
    const barcodeImage = generateBarcode(numeroorc) // Usando número do orçamento para o código de barras

    const totalItens = clientes.reduce((acc, item) => acc + (item.valorunitario * item.quantidade), 0)
    const totalDescontos = clientes.reduce((acc, item) => acc + (item.desconto || 0), 0)
    const valorFinal = totalItens - totalDescontos

    // Header da empresa - Igual ao pedido
    const companyHeader = {
      margin: [0, 0, 0, 20],
      table: {
        widths: ['*', 'auto'],
        body: [[
          {
            text: [
              { text: empresaInfo?.EMP_RAZAO_SOCIAL || '', fontSize: 14, bold: true, color: darkColor },
              { text: '\n' + (empresaInfo?.EMP_ENDERECO || '') + ', ' + (empresaInfo?.EMP_NUMERO || ''), fontSize: 9, color: '#6b7280' },
              { text: '\n' + (empresaInfo?.EMP_CIDADE || '') + ' - ' + (empresaInfo?.EMP_ESTADO || '') + ' | CEP: ' + (empresaInfo?.EMP_CEP || ''), fontSize: 9, color: '#6b7280' },
              { text: '\nCNPJ: ' + (empresaInfo?.EMP_CNPJ || '') + ' | Tel: ' + (empresaInfo?.EMP_TELEFONE || ''), fontSize: 9, color: '#6b7280' }
            ],
            border: [false, false, false, false]
          },
          {
            image: barcodeImage,
            width: 120,
            alignment: 'right',
            border: [false, false, false, false]
          }
        ]]
      },
      layout: 'noBorders'
    }

    // Título e informações principais - Adaptado para orçamento
    const budgetInfo = {
      margin: [0, 0, 0, 15], // menos espaço no final
      table: {
        widths: ['*', '*', '*'],
        body: [[
          {
            text: [
              { text: 'PROPOSTA COMERCIAL', style: 'title', fontSize: 12 },
              { text: '\nNº ' + numeroorc, fontSize: 10, bold: true, color: warningColor }
            ],
            fillColor: '#fffbeb', // Fundo laranja claro para orçamento
            margin: [10, 10, 10, 10], // padding menor
            border: [false, false, true, false],
            borderColor: [null, null, borderColor, null]
          },
          {
            text: [
              { text: 'DATA\n', fontSize: 8, color: '#6b7280' },
              { text: dataFormatada, fontSize: 12, bold: true, color: darkColor },
              { text: '\n\nVALIDADE\n', fontSize: 8, color: '#6b7280' },
              { text: '15 dias', fontSize: 10, color: warningColor, bold: true }
            ],
            fillColor: lightGray,
            margin: [10, 10, 10, 10],
            border: [false, false, true, false],
            borderColor: [null, null, borderColor, null]
          }
        ]]
      },
      layout: {
        hLineWidth: () => 0,
        vLineWidth: (i) => i === 1 || i === 2 ? 1 : 0,
        vLineColor: () => borderColor,
        paddingLeft: () => 0,
        paddingRight: () => 0,
        paddingTop: () => 0,
        paddingBottom: () => 0
      }
    }
    

    // Dados do cliente - Layout moderno em cards (igual ao pedido)
    const clientInfo = {
      margin: [0, 0, 0, 20],
      table: {
        widths: ['*', '*'],
        body: [[
          {
            text: [
              { text: 'CLIENTE\n', fontSize: 10, bold: true, color: primaryColor },
              { text: NomeCliente + '\n', fontSize: 11, bold: true, color: darkColor },
              { text: 'CPF/CNPJ: ' + cpfFormatado + '\n', fontSize: 9, color: '#6b7280' },
              { text: 'Tel: ' + (DadosCliente?.pes_celular || 'N/I') + '\n', fontSize: 9, color: '#6b7280' },
              ...(Parceiro && Parceiro !== 'Selecione um parceiro' ? [
                { text: 'Indicador: ' + Parceiro, fontSize: 9, color: '#6b7280' }
              ] : [])
            ],
            fillColor: lightGray,
            margin: [15, 15, 15, 15],
            border: [false, false, true, false],
            borderColor: [null, null, borderColor, null]
          },
          {
            text: [
              { text: 'ENDEREÇO\n', fontSize: 10, bold: true, color: primaryColor },
              { text: (DadosCliente?.pes_logradouro || '') + ', ' + (DadosCliente?.pes_numero || '') + '\n', fontSize: 9, color: darkColor },
              { text: (DadosCliente?.pes_complemento || '') + '\n', fontSize: 9, color: darkColor },
              { text: (DadosCliente?.pes_bairro || '') + ', ' + (DadosCliente?.pes_cidade || '') + ' - ' + (DadosCliente?.pes_uf || '') + '\n', fontSize: 9, color: darkColor },
              { text: 'CEP: ' + (DadosCliente?.pes_cep || ''), fontSize: 9, color: darkColor }
            ],
            fillColor: lightGray,
            margin: [15, 15, 15, 15],
            border: [false, false, false, false]
          }
        ]]
      },
      layout: {
        hLineWidth: () => 0,
        vLineWidth: (i) => i === 1 ? 1 : 0,
        vLineColor: () => borderColor,
        paddingLeft: () => 0,
        paddingRight: () => 0,
        paddingTop: () => 0,
        paddingBottom: () => 0
      }
    }

    // Tabela de itens - Design moderno com imagens
    const buildItemsTable = () => {
      const tableBody = [
        // Header da tabela
        [
          { text: 'IMG', style: 'tableHeader' },
          { text: 'CÓDIGO', style: 'tableHeader' },
          { text: 'DESCRIÇÃO', style: 'tableHeader' },
          { text: 'QTD', style: 'tableHeader' },
          { text: 'VALOR UNIT.', style: 'tableHeader' },
          { text: 'TOTAL', style: 'tableHeader' },
          { text: 'OBS', style: 'tableHeader' }
        ]
      ]

      // Agrupamento por ambiente/grupo
      let currentGroup = null
      let groupTotal = 0

      clientes.forEach((item, index) => {
        const itemTotal = item.valorunitario * item.quantidade

        // Verifica se mudou o grupo
        if (item.grupo_item !== currentGroup) {
          // Se tinha grupo anterior, fecha subtotal
          if (currentGroup) {
            tableBody.push([
              {
                text: `SUBTOTAL ${currentGroup}: ${formatCurrency(groupTotal)}`,
                colSpan: 7,
                style: 'totalRow',
                alignment: 'right',
                margin: [0, 8, 0, 8]
              },
              {}, {}, {}, {}, {}, {}
            ])
          }

          // Se existir novo grupo, abre
          if (item.grupo_item) {
            currentGroup = item.grupo_item
            groupTotal = 0
            tableBody.push([
              {
                text: `AMBIENTE: ${currentGroup}`,
                colSpan: 7,
                fillColor: '#e0f2fe',
                color: primaryColor,
                bold: true,
                fontSize: 9,
                margin: [0, 6, 0, 6]
              },
              {}, {}, {}, {}, {}, {}
            ])
          } else {
            currentGroup = null
            groupTotal = 0
          }
        }


        groupTotal += itemTotal

        // Linha do item
        const row = [
          {
            image: item.base64 || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==',
            width: 28,
            height: 28,
            alignment: 'center'
          },
          {
            text: item.codigo?.toUpperCase() || 'N/I',
            style: 'tableCell',
            color: accentColor,
            bold: true
          },
          {
            text: tipoImpressao === 'Resumo'
              ? (item.descricao?.split(' ')[0]?.toUpperCase() || 'N/I')
              : (item.descricao?.toUpperCase() || 'N/I'),
            style: 'tableCell'
          },
          {
            text: formatNumber(item.quantidade),
            style: 'tableCell',
            alignment: 'center',
            fillColor: index % 2 === 0 ? '#f9fafb' : 'white'
          },
          {
            text: formatCurrency(item.valorunitario),
            style: 'tableCell',
            alignment: 'right'
          },
          {
            text: formatCurrency(itemTotal),
            style: 'tableCellBold',
            alignment: 'right',
            color: successColor
          },
          {
            text: item.obs || '-',
            style: 'tableCell',
            fontSize: 7,
            color: '#6b7280'
          }
        ]

        tableBody.push(row)
      })

      // Total do último grupo
      if (currentGroup !== null) {
        tableBody.push([
          {
            text: `SUBTOTAL ${currentGroup}: ${formatCurrency(groupTotal)}`,
            colSpan: 7,
            style: 'totalRow',
            alignment: 'right',
            margin: [0, 8, 0, 8]
          }
        ])
      }

      return {
        table: {
          headerRows: 1,
          widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto'],
          body: tableBody
        },
        layout: {
          fillColor: (rowIndex) => {
            if (rowIndex === 0) return primaryColor
            return null
          },
          hLineWidth: (i, node) => i === 0 || i === node.table.body.length ? 1 : 0.5,
          vLineWidth: () => 0.5,
          hLineColor: () => borderColor,
          vLineColor: () => borderColor
        },
        dontBreakRows: true,
        keepWithHeaderRows: 1
      }

    }

    // Resumo financeiro - Design em cards
    const financialSummary = {
      margin: [0, 20, 0, 0],
      table: {
        widths: ['*', '*', '*'],
        body: [[
          {
            text: [
              { text: 'SUBTOTAL\n', fontSize: 9, color: '#6b7280' },
              { text: formatCurrency(totalItens), fontSize: 12, bold: true, color: darkColor }
            ],
            fillColor: lightGray,
            margin: [12, 12, 12, 12],
            border: [false, false, true, false],
            borderColor: [null, null, borderColor, null],
            alignment: 'center'
          },
          {
            text: [
              { text: 'DESCONTO\n', fontSize: 9, color: '#6b7280' },
              { text: formatCurrency(totalDescontos), fontSize: 12, bold: true, color: '#dc2626' }
            ],
            fillColor: lightGray,
            margin: [12, 12, 12, 12],
            border: [false, false, true, false],
            borderColor: [null, null, borderColor, null],
            alignment: 'center'
          },
          {
            text: [
              { text: 'TOTAL GERAL\n', fontSize: 9, color: '#6b7280' },
              { text: formatCurrency(valorFinal), fontSize: 14, bold: true, color: successColor }
            ],
            fillColor: '#f0fdf4',
            margin: [12, 12, 12, 12],
            border: [false, false, false, false],
            alignment: 'center'
          }
        ]]
      },
      layout: {
        hLineWidth: () => 0,
        vLineWidth: (i) => i === 1 || i === 2 ? 1 : 0,
        vLineColor: () => borderColor,
        paddingLeft: () => 0,
        paddingRight: () => 0,
        paddingTop: () => 0,
        paddingBottom: () => 0
      }
    }

    // Observações - Design melhorado
    const observations = {
      margin: [0, 20, 0, 0],
      table: {
        widths: ['*'],
        body: [[
          {
            text: [
              { text: 'OBSERVAÇÕES\n', fontSize: 11, bold: true, color: primaryColor },
              { text: obs || 'Nenhuma observação adicional.', fontSize: 9, color: darkColor }
            ],
            fillColor: '#f8fafc',
            margin: [15, 12, 15, 12]
          }
        ]]
      },
      layout: 'noBorders'
    }

    // Termos específicos do orçamento
    const budgetTerms = {
      margin: [0, 20, 0, 0],
      table: {
        widths: ['*'],
        body: [[
          {
            text: [
              { text: '  CONDIÇÕES DA PROPOSTA\n', fontSize: 11, bold: true, color: warningColor },
              { text: '• Produtos sob encomenda ou perfis com medidas específicas não aceitamos trocas\n', fontSize: 9, color: darkColor },
              { text: '• Validade da proposta: 15 dias a partir da data de emissão\n', fontSize: 9, color: darkColor },
              { text: '• Valores sujeitos a alteração sem aviso prévio', fontSize: 9, color: darkColor }
            ],
            fillColor: '#fffbeb',
            margin: [15, 12, 15, 12]
          }
        ]]
      },
      layout: {
        hLineWidth: () => 1,
        vLineWidth: () => 1,
        hLineColor: () => warningColor,
        vLineColor: () => warningColor
      }
    }

    // Footer moderno
    const footer = (currentPage, pageCount) => ({
      margin: [20, 10, 20, 0],
      table: {
        widths: ['*', '*'],
        body: [[
          {
            text: [
              { text: '🖨️ Impresso em ', fontSize: 8, color: '#9ca3af' },
              { text: format(new Date(), 'dd/MM/yyyy às HH:mm', { locale: ptBR }), fontSize: 8, color: '#4b5563' },
              { text: '\nZipHub Gestão - Sistema Integrado', fontSize: 7, color: '#9ca3af' }
            ],
            border: [false, false, false, false]
          },
          {
            text: [
              { text: `Página ${currentPage} de ${pageCount}`, fontSize: 8, color: '#4b5563' }
            ],
            alignment: 'right',
            border: [false, false, false, false]
          }
        ]]
      },
      layout: 'noBorders'
    })

    // Definição final do documento
    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [40, 60, 40, 60],
      content: [
        companyHeader,
        budgetInfo,
        clientInfo,
        { text: '\n' },
        buildItemsTable(),
        financialSummary,
        observations,
        budgetTerms
      ],
      footer: footer,
      styles: styles,
      defaultStyle: {
        font: 'Roboto',
        fontSize: 10,
        lineHeight: 1.3
      }
    }

    // Gerar PDF
    pdfMake.createPdf(docDefinition).open()

  } catch (error) {
    console.error('Erro ao gerar PDF:', error)
    alert('Erro ao gerar o relatório. Verifique os dados e tente novamente.')
  }
}

export default reportOrcNoWMS